import { Inject } from 'inversify-props'
import { ItemDoCarrinho } from '@/models/venda/Carrinho'
import type { ItemDoCarrinhoServiceAdapter } from './adapter/ItemDoCarrinhoServiceAdapter'

export class ItemDoCarrinhoUseCase {
	@Inject('ItemDoCarrinhoServiceAdapter')
	private itemDoCarrinhoServiceAdapter!: ItemDoCarrinhoServiceAdapter

	salvarOuAtualizarItemDoCarrinho = async (carrinhoId: string, item: ItemDoCarrinho): Promise<boolean> =>
		await this.itemDoCarrinhoServiceAdapter.salvarOuAtualizarItemDoCarrinho(carrinhoId, item)

	removerItemDoCarrinho = async (produtoId: string, carrinhoId: string): Promise<void> =>
		await this.itemDoCarrinhoServiceAdapter.removerItemDoCarrinho(produtoId, carrinhoId)
}
